import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { DataInput, TrivUIToolsLibModule }  from '@trivelope/triv-ui-tools-lib';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { Environment } from 'src/app/classes/environment';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from 'src/app/services/user.service';


@Component({
	selector: 'app-change-address',
	templateUrl: './change-address.component.html',
	styleUrls: [ './change-address.component.scss' ],
	standalone: true,
	imports: [ FormsModule, ReactiveFormsModule, TrivUIToolsLibModule, MatButtonModule ]
})
export class ChangeAddressComponent implements OnInit, OnDestroy {


	addressForm: FormGroup<{ [key:string]: FormControl<string> }> = new FormGroup({});

	myInputs: { [name: string]: DataInput } = {};

	subscriptions = new Subscription();

	bInProgress = false;
	errorMsg = "";


	constructor(
		private authenticationService: AuthenticationService,
		private matSnackBar: MatSnackBar,
		@Inject('environment') public environment: Environment,
		private userService: UserService,
		@Inject('LOCALSTORAGE') private localStorage: Storage,
	) {

		for( let dataInput of this.environment.user ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}

	}


	ngOnInit() {

		// timeout to give enough the UI enough time to load the form
		setTimeout( () => {

			const user = this.authenticationService.getCurrentUser();
			for( const p in user ) {
				if( !user.hasOwnProperty(p) ) continue;
				const ctrl = this.addressForm.get( p );
				// if( ctrl ) console.log( "P", p, "ctrl found", user[p] )
				if( ctrl ) ctrl.patchValue( user[p] );
			}

		}, 1 );

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	clickUpdateAddress() {

		this.errorMsg = '';

		const user = this.authenticationService.getCurrentUser();
		user.ansStrasse = this.addressForm.value.ansStrasse || "";
		user.ansHausnummer = this.addressForm.value.ansHausnummer || "";
		user.ansOrt = this.addressForm.value.ansOrt || "";
		user.ansPlz = this.addressForm.value.ansPlz || "";

		this.bInProgress = true;
		this.userService.updateUserAddress( user ).subscribe( result => {

			this.bInProgress = false;

			if(  ( typeof(result) == "number" ) || !result.ebeId  ) {
				this.errorMsg = "Beim Ändern der Adresse ist ein Fehler aufgetreten";
				return;
			}

			this.matSnackBar.open( "Erfolgreiche Speicherung", "Erfolg" );

			const currentUser = this.authenticationService.getCurrentUser();
			currentUser.ansStrasse = result.ansStrasse || "";
			currentUser.ansHausnummer = result.ansHausnummer || "";
			currentUser.ansOrt = result.ansOrt || "";
			currentUser.ansPlz = result.ansPlz || "";
			this.localStorage.setItem( 'currentUser', JSON.stringify( currentUser ) );

		});

	}
}
